import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal, Card, Spinner, Row, Col, Badge } from "react-bootstrap";
// import { createGlobalStyle } from 'styled-components'; // Removido
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
// import { getContrastingTextColor, generateContrastPalette } from '../../../utils/colorUtils'; // Removido
import { useColors } from '../../../contexts/ColorContext'; // Adicionado

import { API_BASE_URL as API_BASE } from "../../../config";

// Função para exibir Data/Hora no formato DD/MM/YYYY HH:mm
function toDisplayDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const dia = String(d.getDate()).padStart(2, "0");
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const ano = d.getFullYear();
  const hora = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dia}/${mes}/${ano} ${hora}:${min}`;
}

export default function ConsultarAgendamentos() {
  const navigate = useNavigate();
  const { slug } = useParams();

  const [phone, setPhone] = useState("");
  const [clienteId, setClienteId] = useState(null);
  const [agendamentos, setAgendamentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [idClienteMaster, setIdClienteMaster] = useState(null);
  const [clienteMaster, setClienteMaster] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [toDelete, setToDelete] = useState(null);

  // Hook de cores
  const { updateColors } = useColors(); // Usar updateColors

  // Buscar ClienteMaster ao carregar
  useEffect(() => {
    async function fetchClienteMaster() {
      try {
        // Não chamamos setLoading(true) aqui, pois o estado inicial já é false,
        // e o loading só é ativado na busca de agendamentos.
        const res = await axios.get(`${API_BASE}/ClienteMaster/${slug}`);
        setClienteMaster(res.data);
        setIdClienteMaster(res.data.id);

        // **APLICAÇÃO DA COR CORRIGIDA**
        if (res.data && res.data.configuracaoCores) {
          updateColors(res.data.configuracaoCores);
        }
      } catch (e) {
        console.error("Erro ao buscar ClienteMaster:", e);
        setErr("Não foi possível carregar as informações do cliente.");
      }
    }
    if (slug) fetchClienteMaster();
  }, [slug, updateColors]); // Adicionar updateColors como dependência

  // Buscar agendamentos por telefone
  const buscarAgendamentos = async (telefoneLimpo) => {
    if (!idClienteMaster) return;

    try {
      setLoading(true);
      setErr(null);

      // Buscar cliente pelo telefone
      const clienteRes = await axios.get(`${API_BASE}/Clientes/by-phone`, {
        params: { phone: telefoneLimpo, idClienteMaster },
        validateStatus: s => s >= 200 && s < 500,
      });

      const clienteData = clienteRes.data;
      if (!clienteData?.id && !clienteData?.Id) {
        setAgendamentos([]);
        setClienteId(null);
        window.globalAlert("Nenhum cliente encontrado com esse telefone.", "info");
        return;
      }

      const cid = clienteData.id ?? clienteData.Id;
      setClienteId(cid);

      // Buscar agendamentos do ClienteMaster
      const agRes = await axios.get(`${API_BASE}/Agendamentos`, {
        params: { idClienteMaster },
      });

      const lista = Array.isArray(agRes.data) ? agRes.data : [];
      const agora = new Date();
      agora.setHours(0, 0, 0, 0);

      const filtrados = lista
        .filter(a => (a.clienteId ?? a.ClienteId) === cid)
        .filter(a => !(a.realizado ?? a.Realizado)) // somente pendentes
        .filter(a => {
          const dt = new Date(a.dataHora ?? a.DataHora ?? a.data ?? a.Data);
          return dt >= agora;
        })
        .sort((a, b) => {
          const dtA = new Date(a.dataHora ?? a.DataHora ?? a.data ?? a.Data);
          const dtB = new Date(b.dataHora ?? b.DataHora ?? b.data ?? b.Data);
          return dtA - dtB;
        });

      setAgendamentos(filtrados);
    } catch (e) {
      setErr(e?.response?.data || e?.message || "Erro ao consultar agendamentos.");
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneChange = (e) => {
    let val = e.target.value.replace(/\D/g, "");
    if (val.length > 11) val = val.slice(0, 11);
    const masked = val.replace(/^(\d{2})(\d{5})(\d{0,4})$/, "($1)$2-$3").replace(/-$/, "");
    setPhone(masked);

    if (val.length === 11) {
      buscarAgendamentos(val);
    } else {
      setAgendamentos([]);
      setClienteId(null);
      setErr(null);
    }
  };

  const openConfirm = (ag) => { setToDelete(ag); setShowConfirm(true); };
  const closeConfirm = () => { setShowConfirm(false); setToDelete(null); };

	const confirmarExclusao = async () => {
    const id = toDelete?.id ?? toDelete?.Id ?? toDelete?.agendamentoId;
    
    if (!id) { 
        window.globalAlert("ID do agendamento não encontrado.", "error"); 
        return; 
    }

    try {
        await axios.delete(`${API_BASE}/Agendamentos/${id}/excluir-direto`);

        closeConfirm();
        window.globalAlert("Agendamento excluído com sucesso!", "success");

        setAgendamentos(prev => prev.filter(a => (a.id ?? a.Id) !== id));
        
    } catch (e) {
        window.globalAlert(
            e?.response?.data?.mensagem || e?.message || "Erro ao excluir agendamento.", 
            "error"
        );
    }
};
  /*const confirmarExclusao = async () => {
    const id = toDelete?.id ?? toDelete?.Id ?? toDelete?.agendamentoId;
    if (!id) { window.globalAlert("ID do agendamento não encontrado.", "error"); return; }

    try {
      await axios.post(`${API_BASE}/Agendamentos/solicitar-exclusao`, { agendamentoId: id });
      closeConfirm();
      window.globalAlert("Pedido de confirmação enviado pelo WhatsApp!", "success");
      setAgendamentos(prev => prev.filter(a => (a.id ?? a.Id) !== id));
    } catch (e) {
      window.globalAlert(e?.response?.data || e?.message || "Erro ao solicitar exclusão.", "error");
    }
  };
*/
  // Removido: Lógica de cores e estilos globais que estava aqui.
  // A aplicação das cores agora é feita via CSS Variables no ColorContext.

  return (
    <>
      {/* Removido: Estilos globais desnecessários, o ColorContext já aplica via CSS Variables */}
      <div className="container py-4" /* style={{ color: textColor }} */>
        <h2 className="mb-4 titulo">Consultar Agendamentos</h2>

        <div className="d-flex gap-2 mb-3">
          <input
            type="tel"
            className="form-control"
            placeholder="Digite seu WhatsApp"
            value={phone}
            onChange={handlePhoneChange}
          />
        </div>

        {loading && <div className="text-center my-4"><Spinner animation="border" role="status" /><div>Carregando...</div></div>}
        {err && !loading && <div className="alert alert-danger">{String(err)}</div>}

        {!loading && agendamentos.length > 0 && clienteId && (
          <Row xs={1} sm={2} md={3} lg={3} xl={4} className="g-3">
            {agendamentos.map((ag) => {
              const id = ag.id ?? ag.Id;
              const servico = ag.servico?.nome ?? ag.Servico?.Nome ?? "—";
              const funcionario = ag.funcionario?.nome ?? ag.Funcionario?.Nome ?? "—";
              const dataStr = toDisplayDateTime(ag.dataHora ?? ag.DataHora ?? ag.data ?? ag.Data);
              const realizado = ag.realizado ?? ag.Realizado ?? false;
              const observacao = ag.observacao ?? ag.Observacao ?? "";

              return (
                <Col key={id}>
                  <Card className="h-100 shadow-sm">
                    <Card.Body className="d-flex flex-column">
                      <div className="d-flex align-items-start justify-content-between">
                        <Card.Title className="mb-1">{servico}</Card.Title>
                        <Badge bg={realizado ? "success" : "secondary"}>{realizado ? "Realizado" : "Pendente"}</Badge>
                      </div>
                      <Card.Subtitle className="text-muted mb-2">Profissional: {funcionario}</Card.Subtitle>
                      <div className="mb-2"><strong>Data/Hora:</strong> {dataStr}</div>
                      {observacao && <div className="mb-2"><strong>Obs.:</strong> {observacao}</div>}
                      <div className="mt-auto">
                        <Button variant="outline-danger" size="sm" onClick={() => openConfirm(ag)}>Excluir</Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}

        <div className="button-volta mt-4">
          <Button variant="secondary" onClick={() => navigate(`/${slug}`)}>Voltar</Button>
        </div>

        <Modal show={showConfirm} onHide={closeConfirm} centered>
          <Modal.Header closeButton><Modal.Title>Confirmar exclusão</Modal.Title></Modal.Header>
          <Modal.Body>
            Tem certeza que deseja excluir este agendamento?<br/>
            <small className="text-muted">Esta ação não poderá ser desfeita.</small>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeConfirm}>Cancelar</Button>
            <Button variant="danger" onClick={confirmarExclusao}>Excluir</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}